import React, { useState, useEffect } from 'react';
import DashboardHeader from './DashboardHeader';
import TotalTripsChart from './charts/TotalTripsChart';
import CompletedTripsChart from './charts/CompletedTripsChart';
import tripService from '@/services/tripService';
import Loader from '@/components/ui/loader';

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOverview = async () => {
      try {
        setLoading(true);
        const res = await tripService.getDashboardOverview();
        console.log("Dashboard Overview:", res);
        setData(res);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch dashboard overview:", err);
        setError("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchOverview();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-destructive">
        <p className="font-semibold">{error}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <DashboardHeader data={data} />
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-12 md:col-span-6">
          <TotalTripsChart tripsByStatus={data?.trips_by_status} />
        </div>
        <div className="col-span-12 md:col-span-6">
          <CompletedTripsChart monthlyData={data?.trips_completed_by_month} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;